export default __webpack_public_path__ + "static/computerSmall-ae37a9917ce1af6b37689ce45e0b95a5.png";